import styled, { css } from "styled-components";

const semanticTokens = {
  itemSize: "3rem",
  iconSize: "1.6rem",
};

export interface StyledWrapProps {
  selected?: boolean;
  unclickable?: boolean;
}

export const Wrap = styled.button<StyledWrapProps>`
  background: transparent;
  width: ${semanticTokens.itemSize};
  height: ${semanticTokens.itemSize};
  border-radius: 0.4rem;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme, selected, unclickable }) => css`
    color: ${theme.color.text.tertiery};

    ${unclickable
      ? css`
          cursor: default;
        `
      : css`
          &:hover {
            color: ${theme.color.text.secondary};

            svg {
              color: ${theme.color.grey[500]};
            }
          }
        `}

    svg {
      color: ${theme.color.grey[400]};
      width: ${semanticTokens.iconSize};
      height: ${semanticTokens.iconSize};
    }

    &:disabled {
      cursor: not-allowed;

      svg {
        color: ${theme.color.grey[300]};
      }
    }

    ${selected &&
    css`
      background: ${theme.color.brick[10]};
      color: ${theme.color.text.highEmphasis};
    `}
  `}
`;
